import {
  // FilterUIPlacementEnum,
  IFilter,
} from 'src/components/price-list/types';
import { Price } from 'src/types';
import { IListPrices } from '../types';

const offerHasFilteredInfo = (offer: Price, filters: IFilter[]) => {
  return filters.every(filter => {
    if (filter.treatUnfeaturedAsMissingInfo && !offer.store?.featured) {
      return false;
    }
    return !filter.missingInfoFn || !filter.missingInfoFn(offer);
  });
};

export const getSplitOfferlist = (
  offers: Price[],
  filters: IFilter[]
): IListPrices => {
  const splittedList: IListPrices = {
    mainList: [],
    secondaryList: [],
  };
  if (!offers.length) {
    return splittedList;
  }
  if (!filters.length) {
    splittedList.mainList = offers;
    return splittedList;
  }
  offers.forEach(offer => {
    if (offerHasFilteredInfo(offer, filters)) {
      splittedList.mainList.push(offer);
    } else {
      splittedList.secondaryList.push(offer);
    }
  });
  return splittedList;
};

export const TOTAL_OFFERS_LIMIT = 15;
export const MAIN_LIST_DEFAULT_LIMIT = 10;
export const SECOND_LIST_DEFAULT_LIMIT =
  TOTAL_OFFERS_LIMIT - MAIN_LIST_DEFAULT_LIMIT;

export const getListLimits = (prices: IListPrices) => {
  const maxMainOffers = Math.min(prices.mainList.length, TOTAL_OFFERS_LIMIT);
  const maxSecondOffers = Math.min(
    prices.secondaryList.length,
    TOTAL_OFFERS_LIMIT
  );
  const maxMainOffersWhenSecondaryListIsLimitedByDefault =
    maxSecondOffers > SECOND_LIST_DEFAULT_LIMIT
      ? MAIN_LIST_DEFAULT_LIMIT
      : TOTAL_OFFERS_LIMIT - maxSecondOffers;
  const mainListLimit = Math.min(
    maxMainOffers,
    maxMainOffersWhenSecondaryListIsLimitedByDefault
  );
  const secondaryListLimit = TOTAL_OFFERS_LIMIT - mainListLimit;
  return {
    mainListLimit,
    secondaryListLimit,
  };
};
